export default __webpack_public_path__ + "static/media/Wolfram.60cae4ab.png";